import React from 'react';
import { FaTimes } from 'react-icons/fa';

const ChangeStatusMobileModal = ({
    show,
    onClose,
    onAccept,
    onBilled,
    onCancel,
    canAccept,
    canBilled,
    canCancel
}) => {
    if (!show) return null;

    return (
        <div
            className="d-flex"
            style={{
                width: '100vw',
                height: '100dvh',
                position: 'fixed',
                left: 0,
                top: 0,
                zIndex: 20,
                background: 'rgba(0,0,0,0.07)',
                justifyContent: 'center',
                alignItems: 'end',
                paddingBottom: '90px',
                backdropFilter: 'blur(8px)',
                WebkitBackdropFilter: 'blur(8px)'
            }}
        >
            <div
                className="popup product-popup-mobile d-md-none"
                style={{
                    position: 'relative',
                    transform: 'none',
                    top: 0,
                    left: 0,
                    maxWidth: '90%',
                    background: '#fff',
                    borderRadius: 12,
                    boxShadow: 'rgb(0 0 0 / 37%) 0px 0px 20px',
                    width: '100%',
                    minHeight: '30dvh',
                    padding: '24px 16px 0 16px',
                    display: 'flex',
                    flexDirection: 'column'
                }}
            >
                {/* Header */}
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
                    <h5 style={{ fontWeight: 600, fontSize: 18, margin: 0 }}>
                        Change Status
                    </h5>
                    <button
                        className="btn btn-link p-0"
                        style={{ fontSize: 22, lineHeight: 1 }}
                        onClick={onClose}
                        aria-label="Close"
                    >
                        <FaTimes />
                    </button>
                </div>

                {/* Status Actions */}
                <div className="d-flex flex-column gap-2" style={{ marginBottom: 24 }}>
                    {canAccept && (
                        <button
                            className="btn btn-primary btn-block"
                            onClick={() => {
                                onClose();
                                onAccept && onAccept();
                            }}
                        >
                            Accept
                        </button>
                    )}
                    {canBilled && (
                        <button
                            className="btn btn-primary btn-block"
                            onClick={() => {
                                onClose();
                                onBilled && onBilled();
                            }}
                        >
                            Billed
                        </button>
                    )}
                    {canCancel && (
                        <button
                            className="btn btn-danger btn-block"
                            onClick={() => {
                                onClose();
                                onCancel && onCancel();
                            }}
                        >
                            Cancel
                        </button>
                    )}
                </div>

                {/* Sticky bottom close button */}
                <div
                    className="btnarea"
                    style={{
                        position: 'sticky',
                        bottom: 0,
                        left: 0,
                        width: '100%',
                        background: '#fff',
                        padding: '16px 0 12px 0',
                        zIndex: 30,
                        display: 'flex',
                        gap: 10,
                        justifyContent: 'center',
                        marginTop: 'auto'
                    }}
                >
                    <button className="btn new-btn-error" onClick={onClose}>
                        <FaTimes /> Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ChangeStatusMobileModal;